import urls from './urls.json';

const payerUrlFromEnv = window.PAYER_URL;

export default payerUrlFromEnv || urls.payerUrl;
